import React  from 'react';
import { Link} from "react-router-dom";
import {ShoppingCart} from "phosphor-react";
import {Heart} from "phosphor-react";
import "./navbar.css"
import { Logo } from "../assets";
import { useDarkMode } from '../theme/DarkModeContext';
import { ShopContext } from '../context/shop-context';
import { useContext } from 'react';

export const Navbar = () => {
    const { darkMode, toggleDarkMode } = useDarkMode();
    const { getTotalCartCount } = useContext(ShopContext);
  const totalCartCount = getTotalCartCount();

return (
    
<div className='navbar'>
    <div className='rightSide'>
        <Link to="/"> <img className='logoStyle' src={Logo} /></Link>
    </div>

    <div className='leftSide'>

        <label className="switch">
            <input type="checkbox" checked={darkMode} onChange={toggleDarkMode} />
            <span className="slider"></span>
        </label>
        <div className='links'>
            <Link to="/cart">
            <ShoppingCart size={32} />
            {totalCartCount > 0 && (
            <span className="cart-count">{totalCartCount}</span>
            )}
            </Link>

            <Link to="/favorites">
            <Heart size={32} />
            </Link>
        </div>
    </div>
</div>
)
}